import Vue from 'vue';
import Spin from './spin.vue';

export const KEY = Symbol('V_SPIN_KEY');

/**
 * 创建加载
 * @param el 当前dom节点
 * @param props 属性
 */
export const createSpin = (el, props) => {
  /**
   * 隐藏
   */
  const hide = () => {
    if (vm) {
      vm.$props.visible = false;
    }
  };

  /**
   * 显示
   */
  const show = () => {
    if (vm) {
      vm.$props.visible = true;
    }
  };

  /**
   * 销毁实例
   */
  const destroy = () => {
    el.removeChild(container);
    el[KEY] = undefined;
  };

  /**
   * 隐藏动画结束后的回调
   */
  const afterLeave = () => {
    if (el && vm.$el && container.parentNode) {
      destroy();
      el.classList.remove('spin-parent');
    }
  };

  // 创建容器
  const container = document.createElement('div');
  // 创建构造器
  const constructor = Vue.extend(Spin);
  // 初始化spin实例，生成真实dom
  const vm = new constructor().$mount();
  // 属性赋值
  vm.$props.afterLeave = afterLeave;
  Object.keys(props).forEach(key => {
    vm.$props[key] = props[key];
  });
  // 将spin添加至容器中
  container.appendChild(vm.$el);
  el.classList.add('spin-parent');
  // 将容器加入当前dom节点中
  el.appendChild(container);
  // 显示spin
  vm.$props.visible = true;

  return {
    hide,
    show,
    destroy
  };
};
